import React, { useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import AuthProvider from "./Context/AuthContext";

import ProfileCardPage from "./Page/ProfileCard/ProfileCardPage";

const Loader = () => {
  return <div className="loader"></div>;
};

const MainContent = () => {
  const [loading] = useState(false);
  const location = useLocation();

  return (
    <>
      {loading && <Loader />}
      {!loading && (
        <Routes>
          {/* Root page */}
          <Route path="/" element={<ProfileCardPage />} />

          {/* Dynamic id page */}
          <Route path=":id" element={<ProfileCardPage />} />
        </Routes>
      )}
    </>
  );
};

const Router = () => {
  return (
    <AuthProvider>
      {/* 👇 basename points to /kc folder */}
      <BrowserRouter basename="/profile-card">
        <MainContent />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default Router;